import { useState } from "react";
import { extinguirMutuo, getRecalculo, getValoresCuotas, getValoresDividendo } from "../services/servicesDividendos";
import { DividendoValores, GenerarDivRow } from "../models/dividendos";
import { StatusCode } from "../../../utils/enums";
import { ExtincionDto } from "../models/extincionDto";

export function useGenerarDiv() {
    const [defaultValues, setDefaultValues] = useState<DividendoValores>({
        emisor: '',
        codigoMutuo: '',
        numeroOperacion: '',
        omd: '',
        esAdministrado: true,
        numeroMutuo: 0,
        numeroDividendo: 0,
        direccion: '',
        numeroDividendosCancelados: 0,
        estado: '',
        deudaOriginal: 0,
        saldoActual: 0,
        otrosSegurosMO: 0,
        fechaVencimiento: new Date(),
        fechaActivacion: new Date(),
        nombre: '',
        seguroIncendioMO: 0,
        seguroDesgravamenMO: 0,
        seguroCesantiaMO: 0,
        interesMoraMO: 0,
        gastosCobranzaMO: 0,
        interesMoraPesos: 0,
        gastosCobranzaPesos: 0,
        otrosCargosMO: 0,
        otrosAbonosMO: 0,
        otrosCargosPesos: 0,
        otrosAbonosPesos: 0,
        interesMO: 0,
        amortizacionMO: 0,
        totalPagarPesos: 0,
        totalRecibidoPesos: 0,
        paridadMonedaOrigenPesos: 0,
        fechaPago: new Date().toISOString().split('T')[0],
        condonarCargos: false,
        condonarGastos: false,
        condonarOtrosCargos: false,
        idSeguroCesantia: 0,
        subsidioCubierto: 0,
        subsidioNoCubierto: 0,
        mesesSubsidio: 0,
        otrosSegurosMOParaCobroFuturo: 0,
        seguroIncendioMOParaCobroFuturo: 0,
        seguroDesgravamenMOParaCobroFuturo: 0,
        seguroCesantiaMOParaCobroFuturo: 0
    });
    const [cuota, setCuota] = useState<GenerarDivRow[]>([]);

    const obtenerDividendos = async (idMutuo: number) => {
        const response = await getValoresDividendo(idMutuo);
        if (response.status === StatusCode.Ok) {
            setDefaultValues(prev => ({
                ...prev,
                ...response.data
            }));

            await obtenerCuotas(response.data);
            await calcular(response.data);
        }
    }

    const obtenerCuotas = async (valores: DividendoValores) => {
        const response = await getValoresCuotas(valores);
        if (response.status === StatusCode.Ok) {
            setCuota(response.data);
        }
    }

    const calcular = async (valores: DividendoValores) => {
        const response = await getRecalculo(valores);
        if (response.status === StatusCode.Ok) {
            setDefaultValues(prev => ({
                ...prev,
                ...response.data
            }));
        }
    }

    const extinguir = async (extincion: ExtincionDto, mutuoId: number) => {
        const response = await extinguirMutuo(extincion, mutuoId);
        return response;
    }

    return {
        obtenerDividendos,
        obtenerCuotas,
        calcular,
        setDefaultValues,
        extinguir,
        defaultValues,
        cuota
    };
}